import "./App.css";

import MyResume from "./pages";

function App() {
    return (
        <div className='App'>
            <MyResume />
        </div>
    );
}

export default App;
